// removed by extract-text-webpack-plugin
module.exports = {"title":"styles__title___1pE-x","content":"styles__content___1yDsb","box":"styles__box___35r8Z","button":"styles__button___36oBi","form":"styles__form___3OGHE","selectContainer":"styles__selectContainer___1P_ez","mb18":"styles__mb18___US-V7","btnEmptyState":"styles__btnEmptyState___3KYDd"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/SharedData/styles.css
// module id = 3253
// module chunks = 0